import styled from 'styled-components';

import { media, getGridBase, getThemeColor } from '@utils/styled';

import { NEGATIVE_STICKY_HEADER_HEIGHT } from '@common/constants/ui';
import Typography from '@common/components/Typography';
import LazyImg from '@common/components/LazyImg/LazyImg';

export const Container = styled.div`
  ${getGridBase()};
  margin-top: ${NEGATIVE_STICKY_HEADER_HEIGHT}rem;

  ${media.from1200up`
    margin-top: 0;
  `}
`;

export const ImageContainer = styled.div`
  position: relative;
  grid-column: span 12;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};
  ${({ theme }) =>
    theme.getFluidSpacing(
      'margin-left',
      'widthBased',
      0,
      true,
      'safe-area-inset-left',
    )};
  ${({ theme }) =>
    theme.getFluidSpacing(
      'margin-right',
      'widthBased',
      0,
      true,
      'safe-area-inset-right',
    )};

  ${media.from1200up`
    margin-left: 0;
    margin-right: 0;
    grid-column: span 6;
    margin-bottom: 0;
  `}

  img {
    background-color: ${getThemeColor('bluegrey.95')};
  }

  &::before {
    content: '';
    display: block;
    height: 70vh;
    ${({ theme }) => theme.getFluidSpacing('max-height', 'heroImage', 1)};
    ${({ theme }) => theme.getFluidSpacing('min-height', 'heroImage', 0)};
  }
`;

export const LazyImage = styled(LazyImg)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 12;

  ${media.from640up`
    grid-column: 2 / span 10;
    justify-content: center;
  `}

  ${media.from1200up`
    grid-column: span 6;
    justify-content: center;
  `}
`;

export const Title = styled(Typography).attrs({ variant: 'h2' })`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 2)};

  ${media.from640up`
    margin-top: 0;
  `}
`;

export const Lead = styled(Typography).attrs({ variant: 'paragraph1' })`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};
`;
